import { render, staticRenderFns } from "./location_shipment.vue?vue&type=template&id=1fe5b92e&scoped=true&"
import script from "./location_shipment.vue?vue&type=script&lang=js&"
export * from "./location_shipment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe5b92e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fe5b92e')) {
      api.createRecord('1fe5b92e', component.options)
    } else {
      api.reload('1fe5b92e', component.options)
    }
    module.hot.accept("./location_shipment.vue?vue&type=template&id=1fe5b92e&scoped=true&", function () {
      api.rerender('1fe5b92e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/base/location_general_tab/shipment/location_shipment.vue"
export default component.exports